"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightKeyword = highlightKeyword;
exports.sanitizeDomainQuery = sanitizeDomainQuery;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Sanitize a domain query string by allowing only valid characters
 *
 * @param {string} query Domain query string to sanitize
 * @returns {string} Sanitized domain query string
 */
function sanitizeDomainQuery(query) {
  if (typeof query !== 'string') {
    return '';
  }
  const validChars = /[a-zA-Z0-9\s.\-_]/;
  return query.split('').filter(char => validChars.test(char)).join('');
}

/**
 * Escape special characters in a string to use it in a regular expression
 *
 * @param {string} string String to escape
 * @returns {string} Escaped string
 */
function escapeRegExp(string) {
  if (typeof string !== 'string') {
    return '';
  }
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Highlight occurrences of a keyword in a text
 *
 * @param {string} text Text in which to highlight the keyword
 * @param {string} keyword Keyword to highlight
 * @param {number} searchStringMinLength Minimum length of the keyword to start highlighting
 * @returns {JSX.Element} Text with highlighted keyword
 */
function highlightKeyword(text, keyword, searchStringMinLength = 2) {
  const keywordLowerCase = escapeRegExp(keyword.trim().toLowerCase());
  if (keywordLowerCase.length >= searchStringMinLength) {
    const parts = text.split(new RegExp(`(${keywordLowerCase})`, 'gi'));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, parts?.map((part, i) => part.toLowerCase() === keywordLowerCase ? /*#__PURE__*/_react.default.createElement("mark", {
      key: i
    }, part) : /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: i
    }, part)));
  }
}